import { usersApiPaths } from '@/hooks/api/_paths'
import { useApiRequest } from '@/lib/http-utils'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

export function useDeactivateAccountMutation(options?: UseMutationOptions) {
  const { apiRequest } = useApiRequest()
  return useMutation({
    mutationKey: ['deactivate-account'],
    mutationFn: async () => {
      const response = await apiRequest({
        path: usersApiPaths.deactivateAccount,
        options: { method: 'POST' },
      })

      if (!response.ok) throw new Error('FAILED_TO_DEACTIVATE_ACCOUNT')
    },
    ...options,
  })
}
